export const extConfig = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: true,
    link: true,
    emote: true,
    gif: {
        canAlign: false,
        smallMedia: true,
        defaultWidth: 650,
        defaultAlignment: 'center'
    },
    heading: false,
    textAlignment: false,
    deviation: {
        defaultWidth: 212,
        smallMedia: true,
        canAlign: false,
        canResize: false,
        canConfigure: false
    },
    deviationThumb: {
        defaultWidth: 150,
        canLink: true,
        maxHeight: 600,
        maxWidth: 780
    },
    daVideo: {
        canAlign: false,
        defaultWidth: 212,
        defaultHeight: 119,
        defaultAlignment: 'center'
    },
    gallery: {
        defaultWidth: 650,
        defaultAlignment: 'center',
        defaultGridItemWidth: 150,
        defaultGridItemHeight: 100,
        defaultLayout: 'grid',
        defaultTorpedoRowHeight: 100,
        defaultLayoutSpacing: 8,
        canAlign: false,
        canResize: false,
        canLink: false,
        canConfigure: false,
        smallMedia: true
    },
    paste: true,
    history: true,
    allowUploads: true,
    anchor: false,
    spinner: false,
    blockDragging: false,
    blockquote: true,
    mention: true,
    textColor: false,
    textFont: false,
    textHighlight: false,
    indent: {
        captureTab: false
    },
    hashtag: true,
    muro: true,
    characterCount: false
};

//# sourceMappingURL=config.js.map